/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_3_DescInputs */

const en_vc_mcp_3_desc = /** @type {(inputs: Vc_Mcp_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The native .vectorcraft format is plain JSON, so scripts, AI tools and Git can read, diff and generate your artwork.`)
};

const zh_vc_mcp_3_desc = /** @type {(inputs: Vc_Mcp_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生 .vectorcraft 格式就是纯 JSON，脚本、AI 工具和 Git 都能读取、比较和生成你的作品。`)
};

/**
* | output |
* | --- |
* | "The native .vectorcraft format is plain JSON, so scripts, AI tools and Git can read, diff and generate your artwork." |
*
* @param {Vc_Mcp_3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_3_desc = /** @type {((inputs?: Vc_Mcp_3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_3_desc(inputs)
	return zh_vc_mcp_3_desc(inputs)
});
export { vc_mcp_3_desc as "vc.mcp.3.desc" }